import React from "react";
import { useStyles } from "../../../assets/jss/CustomCircle";
// import { useTheme } from "@material-ui/core/styles";

export default function CustomCircle(props) {
  // const theme = useTheme();
  const { size, score, isApiFailed, isApi } = props;
  const classes = useStyles();
  // const draw = () => {
  //   const ctx = document
  //     .getElementsByClassName(classes.circleCanvas)[0]
  //     .getContext("2d");
  //   const gradient = ctx.createLinearGradient(0, 0, 170, 0);
  //   gradient.addColorStop(0, "#D00000");
  //   gradient.addColorStop(0.7, "#F17106");
  //   gradient.addColorStop(0.8, "#9FD356");
  //   gradient.addColorStop(0.9, "#198FE3");
  //   ctx.strokeStyle = gradient;
  //   ctx.lineWidth = 20;
  //   ctx.arc(
  //     size / 2,
  //     size / 2,
  //     size / 2.5,
  //     0.75 * Math.PI,
  //     0.25 * Math.PI,
  //     false
  //   );
  //   ctx.stroke();
  // };

  var center = { x: size / 2, y: size / 2 };
  var radius = size / 2.5;
  var quadrants = [
    {
      angleStart: Math.PI * 0.75,
      angleEnd: Math.PI * 1.8,
      x1: center.x,
      y1: center.y - radius,
      x2: center.x + radius,
      y2: center.y,
      colorStops: [
        { stop: 0, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#D00000" },
        { stop: 1, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#D00000" },
      ],
    },
    {
      angleStart: Math.PI * 1.8,
      angleEnd: Math.PI * 1.95,
      x1: center.x + radius,
      y1: center.y,
      x2: center.x,
      y2: center.y + radius,
      colorStops: [
        { stop: 0, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#F17106" },
        { stop: 1, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#F17106" },
      ],
    },
    {
      angleStart: Math.PI * 1.95,
      angleEnd: Math.PI * 0.1,
      x1: center.x,
      y1: center.y + radius,
      x2: center.x - radius,
      y2: center.y,
      colorStops: [
        { stop: 0, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#9FD356" },
        { stop: 1, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#9FD356" },
      ],
    },
    {
      angleStart: Math.PI * 0.1,
      angleEnd: Math.PI * 0.25,
      x1: center.x - radius,
      y1: center.y,
      x2: center.x,
      y2: center.y - radius,
      colorStops: [
        { stop: 0, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#198FE3" },
        { stop: 1, color: isApiFailed || (!isApi && !score) ? "rgba(0, 0, 0, 0.11)" : "#198FE3" },
      ],
    },
  ];

  const draw = () => {
    const c = document.getElementsByClassName(classes.circleCanvas)[0] as HTMLCanvasElement;
    const ctx = c.getContext("2d");
    let x:number;
    let y:number;
    let p:number;
    ctx.clearRect(0, 0, size, size);
    const lineWidth = 18;
    // Draw arc quadrants.
    function drawDial() {
      for (let i = 0; i < quadrants.length; ++i) {
        const quad = quadrants[i];
        const grad = ctx.createLinearGradient(
          quad.x1,
          quad.y1,
          quad.x2,
          quad.y2
        );
        // Color stops.
        for (let j = 0; j < quad.colorStops.length; ++j) {
          const cs = quad.colorStops[j];
          grad.addColorStop(cs.stop, cs.color);
        }
        // Draw arc.
        ctx.beginPath();
        ctx.arc(center.x, center.y, radius, quad.angleStart, quad.angleEnd);
        ctx.strokeStyle = grad;
        ctx.lineWidth = lineWidth;
        ctx.stroke();
      }
    }
    drawDial();
    //

    if (score) {
      const startX = center.x + radius * Math.cos(Math.PI * 0.75);
      const startY = center.y + radius * Math.sin(Math.PI * 0.75);
      x = startX;
      y = startY;
      p = 0.015;
      animateScore();
    }

    function animateScore() {
      if (p <= score * 0.015) {
        requestAnimationFrame(animateScore);
        x = center.x + radius * Math.cos(Math.PI * (0.75 + p));
        y = center.y + radius * Math.sin(Math.PI * (0.75 + p));
      }

      ctx.clearRect(0, 0, size, size);
      drawDial();
      ctx.beginPath();
      ctx.arc(x, y, lineWidth * 1.25, 0, 2 * Math.PI);
      ctx.shadowBlur = 10;
      ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
      ctx.lineWidth = 5;
      ctx.strokeStyle =
        p + 0.75 <= 1.8 && p + 0.75 >= 0.75
          ? "#D00000"
          : p + 0.75 > 1.8 && p + 0.75 <= 1.95
          ? "#F17106"
          : p + 0.75 > 1.95 && p + 0.75 <= 2.1
          ? "#9FD356"
          : "#198FE3";
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(x, y, lineWidth * 1.25 - 2, 0, 2 * Math.PI);
      ctx.fillStyle = "#FFF";
      ctx.fill();
      p += 0.015;
    }
  };

  React.useEffect(() => {
    size && draw();
  }, [size, score, isApiFailed, isApi]);
  return (
    <>
      <canvas width={size} height={size} className={classes.circleCanvas} />
    </>
  );
}
